import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { PlayerCard } from "@/components/medusa/PlayerCard";

// Shared shell for Medusa Room section pages (keeps the room's identity, no site navbar).
export function SectionShell({ kicker, title, blurb, color = "#A855F7", children, testId }) {
  return (
    <main className="min-h-screen bg-[#050507] text-ice relative overflow-hidden" data-testid={testId}>
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true"
        style={{ background: `radial-gradient(ellipse 70% 45% at 50% -5%, ${color}22, transparent 70%)` }} />
      <div className="relative max-w-5xl mx-auto px-5 sm:px-8 pt-8 pb-20">
        <div className="flex flex-wrap items-center justify-between gap-3 mb-8">
          <Link to="/medusa" className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.18em] text-ice/50 hover:text-white border border-white/15 rounded-full px-4 py-2 transition-colors" data-testid="section-back">
            <ArrowLeft size={12} /> Back to the Room
          </Link>
          <PlayerCard compact />
        </div>
        <p className="font-mono text-[10px] uppercase tracking-[0.25em]" style={{ color }}>{kicker}</p>
        <h1 className="font-display text-3xl sm:text-4xl font-bold text-white mt-1.5" data-testid={`${testId}-title`}>{title}</h1>
        {blurb && <p className="mt-2.5 text-sm text-ice/55 max-w-2xl leading-relaxed">{blurb}</p>}
        <div className="mt-8">{children}</div>
      </div>
    </main>
  );
}
